export default function() {
    const self = this

    self.loadProfiles()

    if (
      self.role === 'ROLE_PROFESSIONAL' &&
      parseInt(self.$store.state.session.user.id) !== parseInt(self.$route.params.id)
    ) {
        self.$router.push({
            name: 'ProfessionalAccountHome'
        })
    }
}
